import { render, staticRenderFns } from "./ReleaseProduct.vue?vue&type=template&id=3702fb56&"
import script from "./ReleaseProduct.vue?vue&type=script&lang=ts&"
export * from "./ReleaseProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports